import React, { useState } from 'react';
import LogoImg from "./images/logo.png";
import GlobalIcon from "./images/icons/global.svg";
import "./css/navbar.css";
import { useLanguage } from '../context/LanguageContext';

const Navbar = () => {
  const [isLangDropdownOpen, setIsLangDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { currentLanguage, changeLanguage, t, availableLanguages, loading } = useLanguage();

  const toggleLangDropdown = () => {
    setIsLangDropdownOpen(!isLangDropdownOpen);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const handleLanguageChange = (languageCode) => {
    changeLanguage(languageCode);
    setIsLangDropdownOpen(false);
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
    closeMobileMenu();
  };

  const scrollToTop = () => {
    window.scrollTo({ 
      top: 0, 
      behavior: 'smooth' 
    });
    closeMobileMenu();
  };

  return (
    <nav>
        <div className="container">
            <div className="nav-content">
                <div className="logo"> 
                    <img src={LogoImg} alt="logo" />
                </div>

                {/* Mobile menu button */}
                <div className="mobile-menu-toggle" onClick={toggleMobileMenu}>
                    <span className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}></span>
                    <span className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}></span>
                    <span className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}></span>
                </div>

                <div className={`nav-elements ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
                    <ul>
                        <li>
                            <a href="#" className="active" onClick={scrollToTop}>
                                {t('nav.home')}
                            </a>
                        </li>
                        <li>
                            <a href="#" onClick={() => scrollToSection('services-section')}>
                                {t('nav.ourServices')}
                            </a>
                        </li>

                        <li>
                            <a href="#" onClick={() => scrollToSection('about-section')}>
                                {t('nav.aboutUs')}
                            </a>
                        </li>

                        <li>
                            <a href="#" onClick={() => scrollToSection('team-section')}>
                                {t('nav.ourTeam')}
                            </a>
                        </li>
                    </ul>
                </div>


                <div className={`right-content ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
                    <div className="drob-list" role="navigation" aria-label="Language selection">
                        <h2 
                            className='active-lang' 
                            onClick={toggleLangDropdown}
                            style={{ cursor: 'pointer' }}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    toggleLangDropdown();
                                }
                            }}
                            aria-expanded={isLangDropdownOpen}
                            aria-haspopup="true"
                        >
                            <i> <img src={GlobalIcon} alt='icon' /> </i>  {currentLanguage.toUpperCase()}  
                        </h2>
                        <div 
                            className={`list ${isLangDropdownOpen ? 'show' : 'hide'}`}
                            style={{
                                opacity: isLangDropdownOpen ? 1 : 0,
                                visibility: isLangDropdownOpen ? 'visible' : 'hidden',
                                transition: 'opacity 0.3s ease-in-out, visibility 0.3s ease-in-out'
                            }}
                        >
                            {!loading && availableLanguages.map((lang) => (
                                <a 
                                    key={lang.code}
                                    href="#" 
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleLanguageChange(lang.code);
                                    }}
                                    className={currentLanguage === lang.code ? 'active' : ''}
                                    aria-label={`Switch to ${lang.name}`}
                                > 
                                    {lang.code.toUpperCase()} 
                                </a>
                            ))}
                        </div>
                    </div>

                    <a href='#' onClick={() => scrollToSection('contact-section')}>
                        {t('nav.contactUs')}
                    </a>
                </div>
            </div>
        </div>
    </nav>
  );
};

export default Navbar;